interface Props {
    status?: string;
    maxWidth?: number;
    statusAcceptance?: string;
    manualFinish?: boolean;
}

const ChipStatus = ({ status, maxWidth, statusAcceptance, manualFinish }: Props) => {
    const getStatusDetail = (s?: string) => {
        if (!s) return { color: "darker text on bg-light", text: "Pendente" };

        const statusMap: { [key: string]: { color: string, text: string } } = {
            "PENDING": { color: "darker text on bg-light", text: "Pendente" },
            "SCHEDULED": { color: "darker text on bg-light", text: "Agendado" },
            "ACCEPTED": { color: "white text on bg-success", text: "Aceitou" },
            "REFUSED": { color: "white text on bg-danger", text: "Recusou" },
            "INTEREST": { color: "white text on bg-success", text: "Área de interesse" },
            "AVOID": { color: "white text on bg-danger", text: "Área a ser evitada" },
            "ONROUTE": { color: "white text on bg-success", text: "Na rota" },
            "DELAYED": { color: "white text on bg-danger", text: "Atrasada" },
            "OVERDUE": { color: "white text on bg-danger", text: "Atrasada" },
            "ESTIMATED": { color: "white text on bg-success", text: "Estimado" },
            "OUTROUTE": { color: "white text on bg-danger", text: "Fora de rota" },
            "EARLY": { color: "white text on bg-warning", text: "Adiantada" },
            'STARTING': { color: 'white text on bg-info', text: "Iniciando..." },
            'NOTSTARTED': { color: 'darker text on bg-light', text: "Não iniciada" },
            'PAUSED': { color: 'white text on bg-status-driving', text: "Pausada" },
            'CANCELED': { color: "white text on bg-danger", text: "Cancelada" },
            'FINISHED': {
                color: statusAcceptance === "ACCEPTED" ? "white text on bg-success" : "white text on bg-danger",
                text: manualFinish ? "Concluída" : "Finalizada",
            },
            'SYSTEM_FINISHED': { color: "white text on bg-danger", text: "Finalizada automaticamente" },
            'MANUALLY_FINISHED_BY_FLEET_MANAGER': { color: "white text on bg-danger", text: "Finalizada" },
            'STARTED': { color: "white text on bg-success", text: "Iniciada" },
            'INTERRUPTED': { color: "white text on bg-danger", text: "Interrompida" },
            'ARRIVED': { color: "white text on bg-success", text: "Chegou" },
            'DONE': { color: "white text on bg-success", text: "Concluída" },
        };
        return statusMap[s] || { color: "darker text on bg-light", text: "Pendente" };
    };


    const statusRc = getStatusDetail(status);
    return (
        <div className={`width-120px ${statusRc.color} rounded-extra-large display-flex flex-direction-row align-items-center justify-content-center gap-4 text-center`}>
            <span className="text-size-14 text-normal margin-10">{statusRc.text}</span>
        </div>
    );
};

export default ChipStatus;